import axios from 'axios';
import { useQuery } from 'react-query';

export interface VersionResponse {
  version: string;
}

const fetchVersion = (): Promise<VersionResponse> => {
  return axios
    .get('/api/version')
    .then((response) => response.data)
    .catch(() => {
      throw new Error('Failed to fetch API version');
    });
};

/**
 * Hook to fetch the application version.
 */
export const useVersion = () => {
  return useQuery<VersionResponse, Error>('version', fetchVersion, {
    staleTime: 30 * 1000, // 30 seconds
    cacheTime: 2 * 60 * 1000, // 2 minutes
    retry: 1,
  });
};
